export default __webpack_public_path__ + "static/media/videoposter.29f5e1a1.jpg";